import React,{forwardRef} from 'react'

const DesignCommissionContent = forwardRef((props,ref) => {
    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // Smooth scrolling animation
        });
      };
     
  return (
    <>
    <div className=' bg-ashred flex items-center justify-center flex-col p-2'>
        <p className='  text-white text-2xl  md:text-2xl lg:text-3xl'>DESIGN & COMMISSIONING SERVICES</p>
    </div>
    <div className='w-full bg-white'>
    <div className=' container flex flex-col mx-auto mt-3 px-2 lg:px-0'>
        <div className=' mx-auto  max-w-screen-xl'>
        <p className=' text-base text-black text-justify'><span className='vollkorn-sc-semibold'>Ashlok’s</span> design and commissioning service epitomizes excellence, blending innovation with precision. Meticulously crafted solutions cater to diverse needs, ensuring seamless integration and optimal performance. Our team’s expertise shines in every detail, from conceptualization to execution, setting industry standards and delivering unparalleled satisfaction. Trust <span className='vollkorn-sc-semibold'>Ashlok</span> for visionary design and flawless commissioning experiences.</p>
        </div>  
        {/* first block start  max-w-6xl*/}
        <div className='mx-auto max-w-screen-xl mt-3 mb-3'>
            <div className='flex flex-col lg:flex-row space-x-0 lg:space-x-20'>
               
                <div className=' flex basis-1/2 flex-col '>

                    <p className=' bg-ashblack text-white p-3 items-center justify-center font-semibold text-2xl'>
                    E.S.E Conventional Lightning Protection Design

                    </p>
                    <p className=' text-justify pt-2 '>
                            At <span className='vollkorn-sc-semibold'>Ashlok</span>, our E.S.E Conventional Lightning Protection Design service combines cutting-edge technology with expert knowledge to create comprehensive lightning protection solutions. Our designs are tailored to your specific requirements, ensuring the utmost safety for your property and assets.
                    </p>
                    {/*<div className="h-4"></div>*/}
                    <div className=' ml-auto mt-15 pr-2 cursor-pointer' onClick={() => scrollToTop()}>
                       
                    </div>
                </div>
                <div className=' flex basis-1/2 flex-col'>

                    <p className=' bg-ashblack text-white p-3 items-center justify-center font-semibold text-2xl'>
                    
                    Risk Assessment of Lightning Protection Design
                    </p>
                    <p className=' text-justify pt-2 '>
                    With our Risk Assessment of Lightning Protection System service, we meticulously analyze potential vulnerabilities in your lightning protection setup. Our thorough assessment helps identify areas of improvement, enabling us to fortify your system and enhance its overall effectiveness.
                    </p>
                    {/*<div className="h-4"></div>*/}
                    <div className=' ml-auto mt-15 pr-2 cursor-pointer' onClick={() => scrollToTop()}>
                   
                    </div>
                </div>


            </div>
        </div>
        {/* second block start */}
        <div className='mx-auto max-w-screen-xl  mb-3'>
            <div className='flex flex-col lg:flex-row space-x-0 lg:space-x-20'>
                

                    <div className=' flex basis-3/4 flex-col'>

                            <p className=' bg-ashblack text-white p-3 items-center justify-center font-semibold text-2xl'>
                            Commissioning of Lightning Protection Design

                            </p>
                            <p className=' text-justify pt-2 '>
                            <span className='vollkorn-sc-semibold'>Ashlok’s</span> Commissioning of Lightning Protection System service ensures that your lightning protection system is installed and integrated seamlessly. Our expert team carefully oversees the commissioning process, guaranteeing that your system operates at peak performance and provides the highest level of safety.
                            </p>
                        {/*<div className="h-8"></div>*/}
                        <div className=' ml-auto mt-15 pr-2 cursor-pointer' onClick={() => scrollToTop()}>
                       
                        </div>
                    </div>

                        <div className=' flex basis-3/4 flex-col '>

                            <p className=' bg-ashblack text-white p-3 items-center justify-center font-semibold text-2xl'>

                            Testing of Existing Lightning Protection System and Earthing System
                            </p>
                            <p className=' text-justify pt-2 '>
                            Our Testing of Existing Lightning Protection System and Earthing System service offers comprehensive evaluations of your current setup. Through meticulous testing and analysis, we identify any potential issues or weaknesses, allowing us to recommend and implement necessary improvements to ensure optimal system functionality and safety.     
                            </p>
                           {/* <div className="h-8"></div>*/}
                            <div className=' ml-auto mt-15 pr-2 cursor-pointer' onClick={() => scrollToTop()}>
                            
                            </div>
                        </div>
                
            </div>
        </div>
       
    </div>
        {/* hide content */}
        <div>
            <p className="sr-only">earthing installation</p>
            <p className="sr-only">soil testing for construction</p>
            <p className="sr-only">soil testing services near me</p>
            <p className="sr-only">earth resistivity tester</p>
            <p className="sr-only">earthing installation            </p>
        </div>
  
</div>
</>
  )
});
DesignCommissionContent.displayName = 'DesignCommissionContent';

export default DesignCommissionContent
